import type React from 'react';
import type { FC } from 'react';

import { clsx } from 'clsx';

import type { TXProps } from './types';

const TD: FC<React.PropsWithChildren<TXProps>> = ({
  right,
  compact,
  children,
  className,
  center,
  dark,
}) => {
  const defaultClasses = [
    center && 'text-center',
    right && 'text-right',
    !right && 'text-left',
    compact && 'py-12',
    !compact && 'py-24',
    `border-b border-solid px-16 ${
      dark ? 'border-gray-main-dark-mode' : 'border-gray-light'
    }`,
  ];

  return (
    <td className={clsx(className || defaultClasses)}>
      <div className="font-body4">{children}</div>
    </td>
  );
};

export default TD;
